import App, { AppProps } from "next/app";
import { Provider } from "react-redux";
import { store } from "../state/store";
import Page from "../components/layout/page";
import "../styles/globals.css";
import "../styles/alert.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-tooltip/dist/react-tooltip.css";
import "react-image-crop/dist/ReactCrop.css";
import { ModalsStoreProvider } from "../state/context/modal.store";
import { AuthStoreProvider } from "../state/context/auth.store";
import { FormQuestionsStoreProvider } from "../state/context/formQuestions.store";
import momentTz from "moment-timezone";
import Head from "next/head";
import { CandidateStatusesStoreProvider } from "../state/context/candidateStatus.store";
import { ReactQueryApiv2Provider } from "../packages/apiv2-react-query/lib/provider";
import "react-phone-number-input/style.css";
import { UserInfoProvider } from "../state/context/userInfo.store";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";

momentTz.tz.setDefault("Europe/London");

const dev = process.env.DOMAIN === ".dev-helloedun.co.uk";

interface MyAppProps extends AppProps {
	index: boolean;
}

class MyApp extends App<MyAppProps> {
	static async getInitialProps({ Component, ctx }) {
		let pageProps = {};

		if (Component.getInitialProps) {
			pageProps = await Component.getInitialProps(ctx);
		}

		const index = ctx.pathname === "/" || ctx.pathname === "/about" ? true : false;

		return { pageProps, index };
	}

	render() {
		const { Component, pageProps, index } = this.props;
		return (
			<>
				<Head>
					<meta name="robots" content={index && !dev ? "index" : "noindex,nofollow"} />
					<title>Edun | The professional network in education.</title>
				</Head>
				<AuthStoreProvider me={pageProps?.me}>
					<Provider store={store}>
						<ReactQueryApiv2Provider bearerToken={() => pageProps.me?.token} baseUrl={process.env.APIV2_BASE_URL}>
							<UserInfoProvider me={pageProps?.me}>
								<ModalsStoreProvider>
									<FormQuestionsStoreProvider>
										<CandidateStatusesStoreProvider me={pageProps?.me}>
											<TooltipProvider delayDuration={200}>
												<Page>
													<Component {...pageProps} />
												</Page>
												<Toaster richColors position="top-center" /> <div id="helpModalParent" />
											</TooltipProvider>
										</CandidateStatusesStoreProvider>
									</FormQuestionsStoreProvider>
								</ModalsStoreProvider>
							</UserInfoProvider>
						</ReactQueryApiv2Provider>
					</Provider>
				</AuthStoreProvider>
			</>
		);
	}
}

export default MyApp;
